module.exports = __webpack_public_path__ + "img/architecturalart_bodyimage02_en.f18e11b4.png";